/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {EMPTY} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {DEFAULT_SNACK_DURATION} from '../../core/constants';
import {DataInitializerService} from '../../data-store/data-initializer.service';
import {LogFactory} from '../../core/logging/log-factory';
import {SnackbarComponent, SnackbarMessage} from '../../shared/snackbar/snackbar.component';
import {DataSelectionDialogComponent} from '../data-selection-dialog/data-selection-dialog.component';

const LOG = LogFactory.createLog('ClearAllDialogComponent');

@Component({
    selector: 'elohn-clear-all-dialog',
    templateUrl: './clear-all-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearAllDialogComponent implements OnInit {

    constructor(
        private readonly dialogRef: MatDialogRef<DataSelectionDialogComponent>,
        private readonly snackBar: MatSnackBar,
        private readonly dataInitializerService: DataInitializerService,
    ) {
    }

    public ngOnInit(): void {
        this.dialogRef.afterClosed()
            .pipe(switchMap((clearAll: boolean) => clearAll ? this.dataInitializerService.clearAll$() : EMPTY))
            .subscribe({
                next: () => this.snackBar.openFromComponent(SnackbarComponent, {
                    data: {message: SnackbarMessage.CLEAR_ALL_CONFIRMATION},
                    duration: DEFAULT_SNACK_DURATION,
                }),
                error: (error: unknown) => LOG.error(error),
            });
    }

}
